var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { ElementRef } from '@angular/core';
import { UIMenuItemComponent } from './menu-item.component';
import { QueryList } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { ViewContainerRef } from '@angular/core';
import { Observable, merge } from 'rxjs';
import { Overlay } from 'app/ui/core/overlay';
import { TemplatePortal } from 'app/ui/core/portal';
var UIMenuComponent = /** @class */ (function () {
    function UIMenuComponent(_elementRef, _overlay, _viewContainerRef) {
        this._elementRef = _elementRef;
        this._overlay = _overlay;
        this._viewContainerRef = _viewContainerRef;
        this.customClass = this._elementRef.nativeElement.className;
    }
    UIMenuComponent.prototype.ngOnDestroy = function () {
        this._destroyComponent();
    };
    UIMenuComponent.prototype.close = function () {
        this._destroyComponent();
    };
    UIMenuComponent.prototype.open = function (triggeredFrom) {
        var _this = this;
        this._triggeredFrom = triggeredFrom;
        this._createOverlay();
        this._subscribeToBackdrop();
        this._subscribeToItems();
        this._subscribeToResizeListener();
        this._updatePosition();
        return Observable.create(function (observer) {
            _this._closeObserver = observer;
        });
    };
    UIMenuComponent.prototype._createOverlay = function () {
        if (!this._overlayRef) {
            var portal = new TemplatePortal(this._templateRef, this._viewContainerRef);
            this._overlayRef = this._overlay.create({ hasBackdrop: true });
            this._overlayRef.attach(portal);
        }
    };
    UIMenuComponent.prototype._subscribeToBackdrop = function () {
        var _this = this;
        this._backdropSubscription = this._overlayRef.backdropClick().subscribe(function () {
            _this._destroyComponent();
        });
    };
    UIMenuComponent.prototype._subscribeToItems = function () {
        var _this = this;
        var emitters = merge.apply(void 0, __spread(this._items.map(function (option) { return option.onSelectItem; })));
        this._itemsSubscription = emitters.subscribe(function () {
            _this.close();
        });
    };
    UIMenuComponent.prototype._subscribeToResizeListener = function () {
        var _this = this;
        this._resizeListener = function () {
            _this._updatePosition();
        };
        window.addEventListener('resize', this._resizeListener);
    };
    UIMenuComponent.prototype._updatePosition = function () {
        var triggeredBox = this._triggeredFrom.nativeElement.getBoundingClientRect();
        var overlayElement = this._overlayRef.overlayElement;
        var overlayBox = overlayElement.getBoundingClientRect();
        overlayElement.style.left = (triggeredBox.right - overlayBox.width - 1) + window.scrollX + 'px';
        overlayElement.style.top = triggeredBox.bottom + window.scrollY + 'px';
    };
    UIMenuComponent.prototype._destroyComponent = function () {
        this._destroyBackdrop();
        this._destroyOverlay();
        this._destroyItems();
        this._destroyResizeListener();
        this._destroyCloseObserver();
    };
    UIMenuComponent.prototype._destroyBackdrop = function () {
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
            this._backdropSubscription = null;
        }
    };
    UIMenuComponent.prototype._destroyCloseObserver = function () {
        if (this._closeObserver) {
            this._closeObserver.next();
            this._closeObserver.complete();
            this._closeObserver = null;
        }
    };
    UIMenuComponent.prototype._destroyItems = function () {
        if (this._itemsSubscription) {
            this._itemsSubscription.unsubscribe();
            this._itemsSubscription = null;
        }
    };
    UIMenuComponent.prototype._destroyOverlay = function () {
        if (this._overlayRef) {
            this._overlayRef.dispose();
            this._overlayRef = null;
        }
    };
    UIMenuComponent.prototype._destroyResizeListener = function () {
        window.removeEventListener('resize', this._resizeListener);
    };
    return UIMenuComponent;
}());
export { UIMenuComponent };
